"use client";

import { useState } from "react";
import Link from "next/link";
import { AlertTriangle, Rocket, ShieldAlert, X } from "lucide-react";
import type { EffectiveMaintenanceSettings } from "@/lib/maintenance";

export function MaintenanceBanner({ settings }: { settings: EffectiveMaintenanceSettings }) {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  const modeIcon =
    settings.mode === "coming_soon" ? (
      <Rocket size={18} />
    ) : settings.mode === "blocked" ? (
      <ShieldAlert size={18} />
    ) : (
      <AlertTriangle size={18} />
    );

  const waDigits = settings.contactWhatsapp.replace(/\D/g, "");
  const waHref = waDigits
    ? `https://wa.me/${waDigits}?text=${encodeURIComponent(
        `Olá! Vim pelo site da Global ERP e gostaria de obter informações.`,
      )}`
    : null;

  return (
    <div className="maint-banner" data-mode={settings.mode} data-accent={settings.accentColor}>
      <div className="maint-banner__inner">
        <span className="maint-banner__badge">
          {modeIcon} {settings.badgeText}
        </span>
        <span className="maint-banner__text">
          <strong>{settings.headline}:</strong> {settings.subheadline}
        </span>
        <div className="maint-banner__actions">
          {waHref ? (
            <a
              href={waHref}
              target="_blank"
              rel="noopener noreferrer"
              className="maint-banner__link"
            >
              {settings.ctaLabel || "Falar com Suporte"}
            </a>
          ) : settings.ctaHref ? (
            <Link href={settings.ctaHref} className="maint-banner__link">
              {settings.ctaLabel || "Entrar em Contato"}
            </Link>
          ) : null}
          <button
            type="button"
            className="maint-banner__close"
            onClick={() => setDismissed(true)}
            aria-label="Fechar aviso"
          >
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}
